module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Thin-58dede7638e9dc13d550d49be8957b45.ttf";